<template>
  <b-row>
    <b-col cols="12">
      <b-modal
        :visible="true"
        size="xl"
        :title="editData ? 'Modificar artículo' : 'Añadir artículo'"
        :ok-title="editData ? 'Modificar artículo' : 'Añadir artículo'"
        :ok-disabled="readOnly"
        :cancel-title="readOnly ? 'Cerrar' : 'Cancelar'"
        id="hover-modal"
        @ok="addProductModalBtn"
        @hidden="modalHidden"
      >
        <b-row v-if="productData">
          <b-col :cols="12">
            <b-row>
              <b-col :cols="8">
                <h4>{{ productData.reference }}</h4>
                Producto predefinido
              </b-col>

              <b-col :cols="4">
                <b-form-group label="Unidades">
                  <b-form-input
                    type="number"
                    :step="1"
                    :min="1"
                    v-model.number="quantity"
                    :disabled="readOnly"
                    @change="changedQty($event)"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col :cols="6">
            <div class="mt-4">
              <h5>Tipo</h5>

              <b-form-row>
                <b-col cols="12">
                  <b-row no-gutters>
                    <b-col cols="12" md="12" lg="12" xl="3">
                      <b-form-radio-group
                        @change="changedType"
                        id="radio-group-1"
                        :disabled="readOnly"
                        v-model="currentVariation"
                        name="radio-options"
                      >
                        <b-row no-gutters>
                          <b-col
                            class="orderStatusBox"
                            :class="{
                              active: currentVariation === elem.status,
                            }"
                            v-for="(elem, i) in productData.variations"
                            :key="i"
                          >
                            <b-row>
                              <b-col align-self="center">
                                <b-form-radio label="a" :value="i">
                                  {{ elem.name }}
                                </b-form-radio>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-form-radio-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-row>
            </div>

            <h5 class="mt-4">
              Precio:
              {{ currentPrice.toFixed(2) }}
              €
            </h5>
          </b-col>
          <b-col cols="6"
            ><h5>Imagen</h5>
            <b-row
              id="viewsDesktop"
              class="mt-3 justify-content-md-between"
              no-gutters
              ><b-col cols="12">
                <img
                  id="imgPrev"
                  style="max-height: 16rem"
                  :src="productData.image"
                /> </b-col></b-row
          ></b-col>
        </b-row>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

import CustomizerAttributeSelector from '@/admin/components/customizer/CustomizerAttributeSelector.vue';
export default {
  name: 'ProductModal',
  props: ['productID', 'editData', 'show', 'readOnly'],

  components: { CustomizerAttributeSelector },
  data() {
    return {
      productData: null,
      currentVariation: null,
      sharedState: store.state,
      quantity: 1,
      currentPrice: 0.0,
    };
  },
  created() {
    if (this.productID === null) {
    } else {
      // new
      actions
        .getPredefinedProduct(this.productID.replace('PRE_', ''))
        .then((y) => {
          this.productData = y.data;

          this.productData.type = 'predefined';

          if (this.editData) {
            this.quantity = this.editData.quantity;

            this.currentVariation = this.productData.variations.findIndex(
              (x) =>
                this.editData.attributes[0].selector_inputs.value === x.name
            );
          } else {
            this.currentVariation = 0;
          }
          this.updatePrice();
        });
    }
  },
  methods: {
    getProductPreview() {
      let arr = [];

      arr.push(this.productData.image);
      return arr;
    },
    changedType() {
      this.updatePrice();
      // this.currentPrice = parseFloat(
      //   this.productData.variations[this.currentVariation].price
      // );
    },

    addProductModalBtn(bvModalEvt) {
      bvModalEvt.preventDefault();

      const images = this.getProductPreview();

      let attributes = [
        {
          label: 'Tipo',
          selector_inputs: {
            name: this.productData.variations[this.currentVariation].name,
            value: this.productData.variations[this.currentVariation].name,
          },
        },
      ];

      if (this.editData) {
        this.$emit(
          'editProduct',
          this.productData,
          attributes,
          this.currentPrice,
          this.quantity,
          null,
          images
        );
      } else {
        this.$emit(
          'addProduct',
          this.productData,
          attributes,
          this.currentPrice,
          this.quantity,
          null,
          images
        );
      }

      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing');
      });
    },

    updatePrice() {
      actions
        .postProductQuotePrice(this.productID.replace('PRE_', ''), {
          type: 'predefined',
          attributes: [
            {
              label: 'Tipo',
              selector_inputs: {
                name: this.productData.variations[this.currentVariation].name,
                value: this.productData.variations[this.currentVariation].name,
              },
            },
          ],
          quantity: this.quantity,
        })
        .then((x) => {
          this.currentPrice = x.data.price;
        });
    },

    allAttributesFilledIn() {
      const numAttributesFilledIn = this.attributes.filter(
        (yyy) =>
          'selector_inputs' in yyy &&
          yyy.selector_inputs &&
          yyy.selector_inputs.value
      ).length;

      return numAttributesFilledIn === this.attributes.length;
    },

    getValueForAttributeType(type) {
      return this.attributes.find((x) => x.reference === type);
    },

    getValueForAttributeTypeAndName(type, name) {
      return this.attributes.find(
        (x) => x.reference === type && x.label === name
      );
    },

    changedQty(newQty) {
      this.updatePrice();
    },

    modalHidden() {
      this.$emit('hidden');
    },
  },
  mounted() {},
  updated() {
    //this.renderViews();
  },
};
</script>

<style lang="scss" scoped>
#viewsDesktop {
  .canvas {
    width: 40em;
    padding-right: 1rem;
    height: 40em;
  }
  .col {
    &:last-child {
      .canvas {
        padding-right: 0;
      }
    }
  }
}
</style>
